const RecipesNavigation = (target: Element) => {
  const method = {
    el: {
      mobileNavigetion: document.querySelector(".recipes-navigation__nav--mobile"),
    },

    init() {
      if (target) {
        const el = {
          hamburger: target.querySelector<HTMLDivElement>(".recipes-navigation__nav-hamburger"),
          navList: target.querySelector<HTMLDivElement>(".recipes-navigation__nav-list"),
          closeBtn: target.querySelector<HTMLDivElement>(".recipes-navigation__nav-item--close"),
        };

        el.hamburger.addEventListener("click", () => {
          target.classList.add("is-open");
        });

        el.closeBtn.addEventListener("click", () => {
          target.classList.remove("is-open");
        });
      }
    },
  };

  method.init();
};

export default RecipesNavigation;
